/* eslint-disable */
import React from 'react';
import { Row, Col, Container } from 'reactstrap';

// other
import TypeWriter from "../../../components/typewriter/typewrite"
// 多语言
import { useTranslation } from "react-i18next";

const words = [
  "<b class='text-success'>Chia</b>",
  "<b class='text-danger'>Filecoin</b>",
  "<b class='text-warning'>Ethereum</b>",
  "<b class='text-parimary'>Solana</b>",
];

const BannerComponent = () => {

  const { t } = useTranslation();

    return (
      <div>
        <div className="static-slider10" data-aos="fade-up-right">
          <Container>
            <Row className="justify-content-center">
              <Col md="12" className="align-self-center text-center">
                <h1 className="title">{t("ABOUT MiPOOl")}</h1>
              </Col>
              <h5 className="subtitle">
                <TypeWriter
                  prefix={"We Are Sepcialized In "}
                  words={words}
                  suffix={""}
                />{" "}
              </h5>
            </Row>
          </Container>
        </div>
      </div>
    );
}

export default BannerComponent;
